// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eemr","controls":"styles_controls__3C2H0","charLimit":"styles_charLimit__3De-M","input":"styles_input__3sCvN","send":"styles_send__2pSsL"};